import { Injectable } from '@angular/core';
import { BaseCrudService } from '../../../core/data/services/base-crud.service';
import { Observable } from 'rxjs';
import {
  BankSummaryDto,
  BranchSummaryDto,
  BankDetailDto,
  CreateBankDto,
  UpdateBankDto,
  BranchDetailDto,
  CreateBranchDto,
  UpdateBranchDto,
} from '../../../core/data/new-dtos/bank.dtos';

@Injectable({ providedIn: 'root' })
export class BanksService extends BaseCrudService<BankSummaryDto> {
  controller = 'Banks';

  // GET /api/Banks
  getBanks(): Observable<BankSummaryDto[]> {
    return this.httpClient.get<BankSummaryDto[]>(`${this.controller}`);
  }

  // GET /api/Banks/{bankId}
  getBankById(bankId: number): Observable<BankDetailDto> {
    return this.httpClient.get<BankDetailDto>(`${this.controller}/${bankId}`);
  }

  // POST /api/Banks
  createBank(dto: CreateBankDto): Observable<BankDetailDto> {
    return this.httpClient.post<BankDetailDto>(`${this.controller}`, dto);
  }

  // PUT /api/Banks/{bankId}
  updateBank(bankId: number, dto: UpdateBankDto): Observable<BankDetailDto> {
    return this.httpClient.put<BankDetailDto>(`${this.controller}/${bankId}`, dto);
  }

  // DELETE /api/Banks/{bankId}
  deleteBank(bankId: number): Observable<void> {
    return this.httpClient.delete<void>(`${this.controller}/${bankId}`);
  }

  // GET /api/Banks/{bankId}/branches
  getBranches(bankId: number): Observable<BranchSummaryDto[]> {
    return this.httpClient.get<BranchSummaryDto[]>(
      `${this.controller}/${bankId}/branches`,
    );
  }

  // GET /api/Banks/branches/{branchId}
  getBranchById(branchId: number): Observable<BranchDetailDto> {
    return this.httpClient.get<BranchDetailDto>(`${this.controller}/branches/${branchId}`);
  }

  // POST /api/Banks/{bankId}/branches
  createBranch(bankId: number, dto: CreateBranchDto): Observable<BranchDetailDto> {
    return this.httpClient.post<BranchDetailDto>(`${this.controller}/${bankId}/branches`, dto);
  }

  // PUT /api/Banks/branches/{branchId}
  updateBranch(branchId: number, dto: UpdateBranchDto): Observable<BranchDetailDto> {
    return this.httpClient.put<BranchDetailDto>(`${this.controller}/branches/${branchId}`, dto);
  }

  // DELETE /api/Banks/branches/{branchId}
  deleteBranch(branchId: number): Observable<void> {
    return this.httpClient.delete<void>(`${this.controller}/branches/${branchId}`);
  }
}
